import {SystemPrimaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";

export default function DetailedGameBottomBar({ isDisabled, route }) {
    // Used in SingleKnowledgeScreen to display modal
    // bottom bar with both back and launch flash action

    // BUILD
    return (
        <div className={"w-full bg-gradient-to-br from-backgroundLight3 to-backgroundLight1 border-t-1 border-greyLight5 p-[16px]"}>
            <SystemPrimaryCustomButton
                label={"Lancer le jeu"}
                isDisabled={isDisabled}
                isLoading={false}
                isFullWidth={true}
                sizeStyle={kButtonStyles.largeButtonStyle}
                internalLink={route} />
        </div>
    );
}